<template>
  <div class="iv-page">
    <div class="gs-page-hero">
      <div class="gs-hero-art is-interviews" aria-hidden="true"></div>
      <div class="gs-page-hero-inner">
        <div>
          <h1>数匠领袖</h1>
          <p>专家观点、行业观察与一线实践。</p>
        </div>
      </div>
      <div class="gs-page-hero-metrics">
        <div class="gs-page-hero-metric">
          <div class="metric-num"><em>{{ total }}</em></div>
          <div class="metric-label">篇公开访谈</div>
        </div>
      </div>
    </div>

    <div class="iv-body">
      <div v-if="dataList && dataList.length > 0">
        <div class="card-container">
          <div
            v-for="(item, index) in dataList"
            :key="index"
            class="card-item"
            >
            <img :src="prodUrl + item.expertPicture" alt="" class="card-image" />
            <div class="card-content">
              <div class="card-name ellipsis-one" :title="item.name + '：' + item.title">{{ item.name }}: {{ item.title}}</div>
              <div class="card-description opa6">
                {{ stripHtml(item.content) }}
              </div>
              <div class="card-bottom">
                <div>
                  <div v-if="item.rangeTypeName" class="display-flex">
                    <div
                      v-for="(itemType, indexType) in (item.rangeTypeName).split(',')"
                      :key="indexType"
                      class="type-icon"
                    >
                      {{ itemType }}
                    </div>
                  </div>
                </div>
                <div @click="nameDetail(item)" class="more-detail hand-cursor">
                  查看详情
                  <img src="@/assets/images/＞＞@2x.png" class="icon-more blue-text ml5"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <NoData />
      </div>
      <div class="table-pagination">
        <GsPagination
          :current-page="currentPage"
          :page-size="pageSize"
          :total="total"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import NoData from '@/components/NoData/index.vue'
import { interviewList } from "@/api/api";
import { enumType } from '@/utils/enum.js'
import { getDataType } from '@/api/Layout/index.js'
import GsPagination from '@/components/GsPagination/index.vue'
import { P } from '@/router/paths'

export default {
  name: 'UserDetailMore',
  components: { NoData, GsPagination },
  data() {
    return {
      loading: false,
      title: (this.$route.meta && this.$route.meta.title) || '',
      prodUrl: "https://shujuzichan.com/xwzx",
      activeName: '2',
      labelList: [],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      dataList: [
        {
          "createTime": "2025-09-01 07:06:56",
          "updateTime": "2025-09-01 07:06:56",
          "id": 42,
          "homePicture": "/profile/upload/2025/09/01/472dc01b16cfbb10712ec67054a45442_20250901070539A047.jpg",
          "chineseTitle": "第一批高质量数据集方向标准/技术文件验证试点典型单位发布",
          "englishTitle": null,
          "newsSource": "国家数据局",
          "status": 0,
          "whetherOriginal": 0,
          "digest": "在2025年中国国际大数据产业博览会“数据标准化”主题交流活动上，第一批高质量数据集方向标准/技术文件验证试点典型单位及《高质量数据集 建设指南》《高质量数据集 格式要求》《高质量数据集 分类指南》《高质量数据集 质量评测规范》等4项技术文件正式发布。",
          "type": "[\"1\",\"2\"]",
          "typeName": "24H快报,热点新闻",
          "rangeType": "[\"1\",\"5\"]",
          rangeTypeName: "时政新闻,行业新闻",
          "area": "[100000]",
          "newest": 1,
          "areaName": "中国",
      },
      {
          "homePicture": "/profile/upload/2025/07/22/科技风活动邀请函公众号首图_20250722150835A044.png",
          "chineseTitle": "北方大数据交易中心超前实现“半年红”",
          "newsSource": "滨海新区数据局",
          "status": 0,
          "whetherOriginal": 0,
          "digest": "2025年上半年，北方大数据交易中心着力提升平台能级，有效激活数据要素价值，助力新区数字经济高质量发展。截至6月底，累计数据交易额超9亿元，年内数据交易额超3亿元，完成全年目标任务约57%。",
          "type": "[\"2\",\"1\"]",
          "typeName": "热点新闻,24H快报",
          "rangeType": "[\"2\"]",
          rangeTypeName: "地区新闻",
          "area": "[100000,120000]",
          "newest": 1,
          "areaName": "中国,天津市",
        },
        {
          name: '昂见过',
          title: '数聚生态合力，智启价值新篇——2025中国国际大数据产业博览会“数据交易生态大会”在贵阳成功举办',
          content: '2025年8月29日下午，2025中国国际大数据产业博览会“数据交易生态大会”在贵阳国际生态会议中心成功举办。大会由中国国际大数据产业博览会组委会指导，北京国际大数据交易所、深圳数据交易所、贵阳大数据交易所联合主办，吸引了来自国家部委、地方政府、科研院所、金融机构、行业龙头企业以及数据交易机构的300余位代表出席，围绕全国一体化数据市场建设、数据资产管理与产业融合发展等议题展开深入交流，并集中发布一批标志性成果。'
        },
        {
          name: '昂见过',
          title: '数聚生态合力，智启价值新篇——2025中国国际大数据产业博览会“数据交易生态大会”在贵阳成功举办',
          content: '2025年8月29日下午，2025中国国际大数据产业博览会“数据交易生态大会”在贵阳国际生态会议中心成功举办。大会由中国国际大数据产业博览会组委会指导，北京国际大数据交易所、深圳数据交易所、贵阳大数据交易所联合主办，吸引了来自国家部委、地方政府、科研院所、金融机构、行业龙头企业以及数据交易机构的300余位代表出席，围绕全国一体化数据市场建设、数据资产管理与产业融合发展等议题展开深入交流，并集中发布一批标志性成果。'
        },
        {
          name: '昂见过',
          title: '数聚生态合力，智启价值新篇——2025中国国际大数据产业博览会“数据交易生态大会”在贵阳成功举办',
          content: '2025年8月29日下午，2025中国国际大数据产业博览会“数据交易生态大会”在贵阳国际生态会议中心成功举办。大会由中国国际大数据产业博览会组委会指导，北京国际大数据交易所、深圳数据交易所、贵阳大数据交易所联合主办，吸引了来自国家部委、地方政府、科研院所、金融机构、行业龙头企业以及数据交易机构的300余位代表出席，围绕全国一体化数据市场建设、数据资产管理与产业融合发展等议题展开深入交流，并集中发布一批标志性成果。'
        },
        {
          name: '昂见过',
          title: '数聚生态合力，智启价值新篇——2025中国国际大数据产业博览会“数据交易生态大会”在贵阳成功举办',
          content: '2025年8月29日下午，2025中国国际大数据产业博览会“数据交易生态大会”在贵阳国际生态会议中心成功举办。大会由中国国际大数据产业博览会组委会指导，北京国际大数据交易所、深圳数据交易所、贵阳大数据交易所联合主办，吸引了来自国家部委、地方政府、科研院所、金融机构、行业龙头企业以及数据交易机构的300余位代表出席，围绕全国一体化数据市场建设、数据资产管理与产业融合发展等议题展开深入交流，并集中发布一批标志性成果。'
        },
        {
          name: '昂见过',
          title: '数聚生态合力，智启价值新篇——2025中国国际大数据产业博览会“数据交易生态大会”在贵阳成功举办',
          content: '2025年8月29日下午，2025中国国际大数据产业博览会“数据交易生态大会”在贵阳国际生态会议中心成功举办。大会由中国国际大数据产业博览会组委会指导，北京国际大数据交易所、深圳数据交易所、贵阳大数据交易所联合主办，吸引了来自国家部委、地方政府、科研院所、金融机构、行业龙头企业以及数据交易机构的300余位代表出席，围绕全国一体化数据市场建设、数据资产管理与产业融合发展等议题展开深入交流，并集中发布一批标志性成果。'
        },
        {
          name: '昂见过',
          title: '数聚生态合力，智启价值新篇——2025中国国际大数据产业博览会“数据交易生态大会”在贵阳成功举办',
          content: '2025年8月29日下午，2025中国国际大数据产业博览会“数据交易生态大会”在贵阳国际生态会议中心成功举办。大会由中国国际大数据产业博览会组委会指导，北京国际大数据交易所、深圳数据交易所、贵阳大数据交易所联合主办，吸引了来自国家部委、地方政府、科研院所、金融机构、行业龙头企业以及数据交易机构的300余位代表出席，围绕全国一体化数据市场建设、数据资产管理与产业融合发展等议题展开深入交流，并集中发布一批标志性成果。'
        }
      ],
    }
  },
  computed: {
    transFormEnum() {
      return function(enumList, value, multi) {
        if(value) {
          let valObj = []
          if(multi) {
            valObj = JSON.parse(value)
          } else {
            valObj = value.split(',').map(item => item.trim())
          }
          let labelListEnum = []
          if(enumList && enumList.length > 0) {
            enumList.forEach(item => {
              valObj && valObj.forEach(itemObj => {
                if(itemObj === item.value) {
                  labelListEnum.push(item.label)
                }
              })
            })
          }
          return labelListEnum.join(',')
        } else {
          return ''
        }
      }
    }
  },
  created() {
    this.interviewList(this.currentPage, this.pageSize)
    this.getData('sys_live_course_classification')
  },
  methods: {
    nameDetail(item) {
      this.$router.push(P.interviewDetail(item.id)) 
    },
    stripHtml(html) {
      return html.replace(/<[^>]*>/g, '')
    },
    async getData(type) {
      try {
        const res = await getDataType(type)
        if (res && res.data && res.data.length > 0) {
          if(type === 'sys_live_course_classification') {
            this.labelList = enumType(res.data)
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error)
      }
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.interviewList(this.activeName, this.currentPage, this.pageSize)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.interviewList(this.activeName, this.currentPage, this.pageSize)
    },
    interviewList(currentPage, pageSize) {
      var formData = {}
      formData["pageNum"] = currentPage
      formData["pageSize"] = pageSize
      formData["publishStatus"]=1
      interviewList(formData).then((response) => {
        this.dataList = response.rows
        this.total = response.total
      })
    },
  }
}
</script>

<style lang="css" scoped>
.iv-page {
  width: 100%;
  padding-bottom: 40px;
  box-sizing: border-box;
}
.iv-page .gs-page-hero {
  margin-bottom: 18px;
}
.iv-body {
  width: min(var(--gs-main-width, 1250px), calc(100% - 32px));
  margin: 0 auto;
}

.card-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  margin-bottom: 20px;
}

.card-item {
  background: linear-gradient( 180deg, #FFFFFF 0%, #F3F8FF 100%);
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  padding: 5px;
  
  &:hover {
    transform: translateY(-5px);
  }
}

.card-image {
  width: 100%;
  height: 180px;
  object-fit: cover;
  border-radius: 10px 10px 0 0;
}

.card-content {
  padding: 10px 15px;
}

.card-name {
  font-family: AlibabaPuHuiTi_3_85_Bold;
  font-size: 20px;
  color: #111824;
  line-height: 28px;
  text-align: left;
  font-style: normal;
  font-weight: 700;
  margin-bottom: 5px;
}

.card-title {
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.card-description {
  font-family: AlibabaPuHuiTi_3_55_Regular;
  font-size: 14px;
  color: #111824;
  line-height: 26px;
  text-align: left;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.table-pagination {
  margin-top: 30px;
}

.ellipsis-one {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.card-bottom {
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
}
.type-icon {
  background: linear-gradient( 263deg, #E3EEFF  0%, #E0ECFF 100%);
  box-shadow: 2px 2px 4px 0px rgba(46,119,233,0.19);
  border-radius: 4px;
  height: 14px;
  padding: 2px 10px;
  font-family: AlibabaPuHuiTi_3_65_Medium;
  font-size: 10px;
  color: #0165FF;
  line-height: 14px;
  font-style: normal;
  margin-right: 8px;
}
.more-detail {
  height: 17px;
  font-family: AlibabaPuHuiTi_3_55_Regular;
  font-size: 12px;
  color: #343B49;
  line-height: 17px;
  text-align: left;
  font-style: normal;
  display: flex;
  align-items: center;
}
.icon-more {
  width: 10px;
  height: 8px;
}
@media (max-width: 1100px) {
  .card-container {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 960px) {
  .iv-page .gs-page-hero {
    margin-bottom: 12px;
  }
  .iv-body {
    width: calc(100% - 24px);
  }
  .card-container {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
  }
  .card-image {
    height: 140px;
  }
  .card-name {
    font-size: 15px;
    line-height: 22px;
  }
  .card-description {
    font-size: 12px;
    line-height: 18px;
  }
}
@media (max-width: 640px) {
  .card-container {
    grid-template-columns: 1fr;
  }
}
</style>